import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs-simple-table',
  templateUrl: './simple-table.component.html',
  styleUrls: ['./simple-table.component.scss']
})
export class SimpleTableComponent {
  @Input() titles!: string[];
  @Input() itens!: (string | number)[][];
}
